import axios, { InternalAxiosRequestConfig } from "axios";
import { tokenService } from "../services/token.service";
import { removePermissions, removeUserName } from "../services/user.service";
import { authService } from "../services/auth.service";
import {
  clearEstablishmentCode,
  getEIFromUrl,
  getEstToken,
} from "../services/establishment.service";

export const GlobalAxios = axios.create({
  headers: {
    "Access-Control-Allow-Origin": "*",
    client_id: process.env.CLIENT_ID,
  },
});

GlobalAxios.interceptors.request.use(function (config) {
  let token = getEstToken();

  if (token) {
    config.headers.Authorization = "Bearer " + token.token;
  }

  return config;
});

export const InterceptorRefresh = async (
  config: InternalAxiosRequestConfig<any>
) => {
  if (!tokenService.hasRefreshTokens()) {
    return config;
  }

  const establishmentcode = getEIFromUrl();

  let token = tokenService
    .getAccessTokens()
    .find((t) => t.code === establishmentcode);

  const tokens = await refreshToken(token?.establishmentId);

  if (tokens && establishmentcode !== undefined) {
    tokenService.saveTokens(
      tokens.token,
      tokens.refreshToken,
      tokens.establishmentTenantSequential,
      token?.establishmentId
    );
    config.headers.Authorization = "Bearer " + tokens.token;
  }

  return config;
};

export const removeUserData = () => {
  tokenService.removeAllTokens();
  removePermissions();
  clearEstablishmentCode();
  removeUserName();
};

const refreshToken = async (establishmentId?: string) => {
  const response = await authService.refreshToken(establishmentId);
  return response.data;
};
